// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterList_wrapper__rO6Cv","header":"FooterList_header__PsVKQ","title":"FooterList_title__13xOk","link":"FooterList_link__JPcwz"};